/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'step-check': {
    width: 14,
    height: 10,
    viewBox: '0 0 14 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.036.764a.9.9 0 010 1.272l-7.2 7.2a.9.9 0 01-1.272 0l-3.6-3.6a.9.9 0 011.272-1.272L5.2 7.327 11.764.764a.9.9 0 011.272 0z" _fill="#fff"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/step-check.js